// skeleton/app/src/components/DataImportNoticeComponent/DataImportNoticeComponent.tsx

import { TabPanel, TabView } from "primereact/tabview";
import { DataUploadComponent } from "../DataUploadComponent/DataUploadComponent";
import { useEffect, useState } from "react";
import ComponentHeader from "../../pages/ComponentHeader";
import { DataNoticeComponent } from "../DataNoticeComponent/DataNoticeComponent";
import "./DataImportNoticeComponent.scss";
import { useNavigate, useParams } from "react-router";
import { useAppContext } from "../../Context";

export const DataImportNoticeComponent = () => {
  const navigate = useNavigate();
  const { tab } = useParams();
  const [activeIndex, setActiveIndex] = useState(0);

  const {
    providerType,
    reviewYear,
    setProviderType,
  } = useAppContext();

  const breadcrumbsTemplate = (item: any, options: any) => {
    return (
      <a
        className={options.className}
        style={{ cursor: "pointer" }}
        onClick={() => setActiveIndex(item.index)}
      >
        <span className={options.labelClassName}>
          {item.label}
        </span>
      </a>
    );
  };

  const dataUploadItems = [
    {
      label: "Upload Center",
      template: breadcrumbsTemplate,
      index: 0,
      path: "",
    },
  ];

  const noticeItems = [
    {
      label: "Data & Notice Center",
      template: breadcrumbsTemplate,
      index: 1,
      path: "",
    },
  ];

  useEffect(() => {
    if (tab === "notice") {
      setActiveIndex(1);
    } else if (tab === "import") {
      setActiveIndex(0);
    } else {
      navigate("/");
    }
  }, [tab, navigate]);

  return (
    <>
      <div
        style={{
          marginTop: "42px",
          marginBottom: "50px",
          marginLeft: "5px",
        }}
      >
        <header
          style={{
            padding: "5px 5px 5px 5px",
            fontSize: "25px",
          }}
        >
          <strong>Data Import/Notice Page</strong>
        </header>

        <div style={{ marginTop: "10px" }}>
          <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => {
              setActiveIndex(e.index);

              if (e.index === 1) {
                navigate("/dataupload/notice");
              } else {
                navigate("/dataupload/import");
              }
            }}
          >
            <TabPanel header="Upload Center">
              <ComponentHeader
                breadcrumbs={dataUploadItems}
                hideProviderTypeDropdown
                providerType={providerType}
                reviewYear={reviewYear}
              />

              <DataUploadComponent
                providerType={providerType}
                reviewYear={reviewYear}
                onChangeProviderType={setProviderType}
              />
            </TabPanel>

            <TabPanel header="Data & Notice Center">
              <ComponentHeader
                breadcrumbs={noticeItems}
                hideProviderTypeDropdown
                providerType={providerType}
                reviewYear={reviewYear}
              />

              <DataNoticeComponent
                providerType={providerType}
                reviewYear={reviewYear}
              />
            </TabPanel>
          </TabView>
        </div>
      </div>
    </>
  );
};